export interface Article {
  id: string;
  title: string;
  summary: string;
  content: string;
  category: string;
  author: string;
  publishDate: string;
  imageUrl: string;
  imageAlt: string;
  views: number;
  comments: number;
  tags: string[];
  isHot: boolean;
  isExclusive: boolean;
}

export const articles: Article[] = [
  {
    id: 'article-001',
    title: '某顶流男星深夜密会神秘女子，两人酒店共度三小时全程被拍',
    summary: '近日有媒体拍到某位当红顶流男星深夜与一神秘女子在某五星级酒店密会，两人全程亲密互动，引发粉丝热议。',
    content: `6月29日晚11时许，有媒体拍到某位当红顶流男星独自驾驶黑色迈巴赫驶入北京某五星级酒店地下车库。约15分钟后，一名身着黑色吊带连衣裙、头戴宽檐遮阳帽的神秘女子从酒店侧门低调进入，与该男星在大堂咖啡厅角落处碰面。

据拍摄者描述，两人见面后举止十分亲密，不仅多次深情拥抱，该男星还数次轻抚女子的头发和脸颊，眼神中满是宠溺。二人在咖啡厅低声交谈约20分钟后，双双起身一同进入电梯，前往酒店客房楼层。拍摄者表示，从电梯楼层指示灯来看，两人去往的是行政套房所在的顶层。

令人玩味的是，该男星在房间内停留约三个小时后，于凌晨2点15分左右独自驾车离开。而神秘女子则在约40分钟后从酒店正门打车离去，全程以口罩和墨镜遮挡面部，显然是有意隐藏身份。两人错峰离开的操作，反而更加坐实了偷偷约会的嫌疑。

消息传出后，该男星的粉丝后援会迅速发布声明，称"艺人私人行程，请勿过度解读"，但并未直接否认照片的真实性。而男星工作室至今已超过48小时保持沉默，这种"冷处理"策略在粉丝群体中引发了更大的不安与讨论。

多位娱乐圈资深记者向每日吃瓜证实，该男星出道十余年来从未传出过任何实质性绯闻，一直以"零绯闻""事业型"形象示人，此次深夜密会被拍堪称"塌房级别"的新闻。有知情人士透露，这位神秘女子并非圈内人，而是某知名风投公司的合伙人，两人疑因商业合作相识。`,

    category: 'star-gossip',
    author: '吃瓜前线记者',
    publishDate: '2026-06-30',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20male%20celebrity%20walking%20into%20luxury%20hotel%20at%20night%20with%20mysterious%20woman%2C%20paparazzi%20style%20photography%2C%20blurry%20night%20scene%2C%20warm%20street%20lights%2C%20editorial%20gossip%20magazine%20aesthetic%2C%20dramatic%20lighting%2C%20cinematic%20mood%2C%20dark%20tones%20with%20neon%20accents&width=800&height=500&seq=chigua-article-001&orientation=landscape',
    imageAlt: '顶流男星深夜密会神秘女子被拍',
    views: 128500,
    comments: 3420,
    tags: ['顶流男星', '深夜密会', '酒店', '绯闻'],
    isHot: true,
    isExclusive: true,
  },
  {
    id: 'article-002',
    title: '知名女主播直播翻车！口误爆出行业内幕，紧急下播仍被录屏',
    summary: '某平台千万粉丝女主播在直播中意外说漏嘴，透露了直播带货行业不为人知的内幕操作，虽然紧急关播但已被网友全程录屏。',
    content: `6月29日晚间，在某短视频平台拥有超过1500万粉丝的知名女主播"甜心baby"在例行直播带货时，因与助播发生口角，情绪失控之下口无遮拦，连续曝出多条直播带货行业的惊人内幕。

据录屏视频显示，该女主播在介绍一款号称"法国进口""专柜价2999元"的面霜时，突然冷笑一声说道："什么法国进口，就是广州白云区代工厂做的，贴个牌而已。我们卖299，成本不到30块。"此言一出，直播间弹幕瞬间炸裂，助播当场愣住，多次试图打断但均未成功。

更令人震惊的是，该女主播随后情绪激动地继续爆料："你们以为只有我们这样？全行业都这样！那些大主播卖的东西，说是品牌方直供，其实都是从同一个档口拿货，谁的直播间卖得动就给谁独家。什么'全网最低价'，都是在出厂价后面加个零。"说完这番话后，她似乎才意识到事情的严重性，面色瞬间惨白，匆忙说了句"我有点不舒服先下了"便关闭了直播。

然而，为时已晚——全程已被数千名观众录屏保存，并在短短两小时内传遍各大社交平台。截至目前，相关视频的全网播放量已突破5000万，话题"主播自曝行业内幕"高居微博热搜榜第二位。

涉事女主播至今未发布任何声明，其直播间已经被平台暂时关闭。而涉事品牌方则火速发布公告，声称与该主播"没有任何合作关系"，但网友随即扒出去年该品牌官方账号亲自为该主播送生日祝福的截图，品牌方的"切割"操作反成笑柄。业内人士分析，此次事件可能引发直播带货行业的大规模信任危机。`,

    category: 'wanghong-black',
    author: '吃瓜前线记者',
    publishDate: '2026-06-30',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20female%20live%20streamer%20surprised%20expression%20in%20streaming%20room%20with%20ring%20light%20and%20products%2C%20dramatic%20moment%2C%20warm%20studio%20lighting%2C%20modern%20streaming%20setup%2C%20editorial%20style%2C%20high%20contrast&width=800&height=500&seq=chigua-article-002&orientation=landscape',
    imageAlt: '女直播主直播翻车口误爆内幕',
    views: 256800,
    comments: 8920,
    tags: ['女主播', '直播翻车', '内幕', '录屏'],
    isHot: true,
    isExclusive: true,
  },
  {
    id: 'article-003',
    title: '独家：某综艺节目录制现场爆发激烈冲突，导演组紧急叫停',
    summary: '据现场工作人员爆料，某热门综艺节目在最新一期录制过程中，两位常驻嘉宾因游戏环节发生激烈争执，场面一度失控。',
    content: `据现场目击者向每日吃瓜独家爆料，6月28日下午，某卫视王牌综艺节目在录制最新一期"密室逃脱"主题内容时，两位常驻男嘉宾因游戏环节中的策略分歧爆发了激烈冲突，场面一度失控，导演组不得不紧急中断录制。

据透露，冲突爆发于一个需要两人配合解密的环节。嘉宾A认为应该按照线索的逻辑顺序逐步推进，而嘉宾B则坚持采用"暴力试错"的方式快速通关。起初只是正常的战术讨论，但随着时间推移和任务压力的增加，两人的语气逐渐升级。嘉宾B突然将手中的道具重重摔在地上，大声吼道："你到底会不会玩？每次都是你拖后腿！"嘉宾A也不甘示弱，反唇相讥："你这么厉害怎么不去参加竞技比赛，来综艺混什么？"

现场气氛瞬间凝固。其他四位常驻嘉宾面面相觑，现场数十名工作人员也都停下了手中的工作。两位当事嘉宾随后又爆出了更多私人恩怨，甚至扯出了一些与节目完全无关的陈年旧事，让在场所有人都意识到这次冲突并非一时冲动，而是长期积怨的爆发。

导演组最终出面将二人分开，分别带到不同的休息室进行安抚。录制被迫中断长达三个小时。据工作人员透露，该期节目原定当天完成录制，但最终只拍了不到一半的内容，剩余部分不得不改期补录。目前节目组正在紧急商讨是否要将这段冲突剪辑进正片——如果保留，必将成为年度最具话题性的综艺名场面；但如果删除，整个密室环节的逻辑链条就会断裂。`,

    category: 'dushijubao',
    author: '内部消息人士',
    publishDate: '2026-06-29',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20recording%20studio%20with%20crew%20members%20looking%20tense%2C%20dramatic%20atmosphere%2C%20stage%20lights%20and%20cameras%2C%20behind%20the%20scenes%20chaos%2C%20warm%20studio%20lighting%2C%20editorial%20documentary%20style&width=800&height=500&seq=chigua-article-003&orientation=landscape',
    imageAlt: '综艺节目录制现场爆发冲突',
    views: 189200,
    comments: 5670,
    tags: ['综艺节目', '冲突', '录制现场', '独家'],
    isHot: true,
    isExclusive: true,
  },
  {
    id: 'article-004',
    title: '某女星与富豪男友分手内幕曝光，分手费高达数千万',
    summary: '知情人透露，某知名女星与身家过亿的富豪男友已经低调分手，分手原因涉及第三者插足，女方获数千万分手费。',
    content: `据多位知情人士向每日吃瓜独家透露，某位在影视圈一线活跃多年的知名女星与相恋三年的富豪男友已于本月初正式分手，分手原因复杂，涉及第三者插足和财产纠纷，女方据传拿到了高达5000万元的分手补偿。

两人的恋情始于2023年初，当时该女星在拍摄一部都市情感剧时通过共同朋友认识了这位从事房地产开发的富豪。男方比女方大12岁，身家据估算超过30亿元。恋爱期间，男方出手极为阔绰，先后赠送了价值超过2000万的北京朝阳区别墅一套、百万级跑车一辆以及大量奢侈品牌珠宝。

然而据接近女方的友人透露，导致分手的关键转折发生在今年4月。女方无意间在男方的手机中发现了与另一名年轻网红的暧昧聊天记录，内容尺度之大让她当场崩溃。更令她无法接受的是，这名网红竟然是男方公司签约的"品牌体验官"，两人的往来已持续近半年之久。

女星最初试图给男方机会，但男方表面认错、背地里依然与对方保持联系。在经历了两个月的拉扯后，女星最终选择果断分手。在律师的介入下，双方达成了一份"分手协议"：女方保留此前收到的所有礼物和房产，男方额外支付5000万元作为"补偿金"，女方则承诺不公开披露分手细节。

虽然有"封口协议"的约束，但消息依然从多个渠道流出。目前女星团队对此事守口如瓶，只表示"艺人私人事务不便回应"。而男方方面则通过公关公司放风，称"双方因性格不合和平分手"，试图淡化外界对"第三者"的关注。`,

    category: 'heiliaotian',
    author: '深度调查组',
    publishDate: '2026-06-29',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20actress%20looking%20sad%20in%20luxury%20apartment%20with%20city%20view%20through%20window%2C%20emotional%20moment%2C%20soft%20warm%20lighting%2C%20high-end%20interior%2C%20cinematic%20portrait%20style%2C%20moody%20atmosphere&width=800&height=500&seq=chigua-article-004&orientation=landscape',
    imageAlt: '女星与富豪男友分手内幕曝光',
    views: 312400,
    comments: 10230,
    tags: ['女星', '分手', '富豪', '分手费'],
    isHot: true,
    isExclusive: false,
  },
  {
    id: 'article-005',
    title: '颁奖典礼后台明星真实关系曝光，表面客气背后互翻白眼',
    summary: '某大型颁奖典礼后台，各路明星的真实互动被摄影师捕捉。有两位素有"姐妹情深"之称的女星在镜头外全程零交流。',
    content: `6月27日晚间举办的某大型年度影视颁奖典礼上，台上星光熠熠、其乐融融，但后台的真实氛围与幕前形成了鲜明对比。每日吃瓜通过多方渠道获取了后台的独家影像资料，揭开了明星们在镜头之外的真实互动状态。

最为引人注目的是两位素有"娱乐圈好闺蜜"之称的一线女星——李某和赵某。两人曾在多档综艺节目中大秀友谊，微博互动频繁，粉丝也一直将她们视为"神仙姐妹情"的代表。然而在当天的颁奖典礼后台，两人被安排在相邻的化妆间，却全程没有任何交流。据现场工作人员描述，李某在走廊偶遇赵某时，两人甚至连眼神都没有对上，各自迅速扭头走进了自己的休息室。

更为戏剧性的是，当李某在上台领奖发表感言时，镜头切到了坐在台下的赵某——虽然她面带微笑在鼓掌，但后台摄影师捕捉到的画面却截然不同：在李某的名字被念出的瞬间，赵某翻了一个明显到不能再明显的白眼，被身旁的经纪人拍了一下才收敛。这段后台画面被传给每日吃瓜后，已在内部引发热烈讨论。

业内人士分析认为，两人的关系恶化和一桩尚未官宣的大制作电影选角有关。据传这部投资超过5亿元的电影原本内定赵某为女主角，但投资方最后介入，换成了李某。虽然此事尚未公开，但圈内早已传得沸沸扬扬。

此外，后台还出现了多个"名场面"：某男团成员在走廊上遇到前辈时90度鞠躬问好却遭对方无视，场面一度尴尬至极；两位竞争同一个代言的女星共用一间休息室，全程以手机和助理为"屏障"，刻意避免任何直接接触，整个房间安静得像考场。`,

    category: 'yulebagua',
    author: '后台观察员',
    publishDate: '2026-06-28',
    imageUrl: 'https://readdy.ai/api/search-image?query=Award%20ceremony%20backstage%20with%20Chinese%20celebrities%20in%20evening%20gowns%2C%20awkward%20atmosphere%20between%20two%20actresses%2C%20dramatic%20tension%2C%20warm%20lighting%2C%20documentary%20photography%20style%2C%20glamorous%20setting&width=800&height=500&seq=chigua-article-005&orientation=landscape',
    imageAlt: '颁奖典礼后台明星真实关系曝光',
    views: 145600,
    comments: 4560,
    tags: ['颁奖典礼', '后台', '明星关系', '塑料姐妹'],
    isHot: false,
    isExclusive: false,
  },
  {
    id: 'article-006',
    title: '某品牌代言人私下吐槽产品被录音，品牌方紧急发律师函',
    summary: '一段疑似某当红明星在私人饭局上吐槽自己代言品牌产品的录音在网络上疯传，品牌方公关团队连夜开会应对危机。',
    content: `6月27日下午，一段时长约3分钟的录音在各大社交平台疯传。录音中，一个与某当红男艺人声音高度相似的人在某私人饭局上对自己代言的某高端护肤品品牌进行了毫不留情的吐槽，内容尺度之大令网友咋舌。

录音中可以清晰听到，疑似该明星的男子在饭桌上对友人说："我跟你说，那个XX精华液我自己从来不用，全是化工原料兑的。一瓶卖两千多，成本有没有两百块我都怀疑。"随后在友人追问"那你为什么还代言"时，该男子笑着回答："废话，他们一年给八位数，不赚白不赚啊。反正广告里又不用我真的用，拍完就走人。"

录音中还涉及了对该品牌其他产品线的评价，包括"那个面霜抹了跟没抹一样""洗面奶就是大皂基，伤皮肤得很"等极为负面的评价。更糟糕的是，该男子还提到"他们质检其实一直有问题，去年被药监局约谈过，后来花了大价钱才压下来的"，这一说法如果属实，将对品牌造成毁灭性打击。

事件爆发后，品牌方公关团队连夜召开紧急会议。次日凌晨，品牌方通过官方微博发布了一纸措辞严厉的律师声明，称该录音"系恶意剪辑和AI合成"，并表示已向公安机关报案，将追究造谣者的法律责任。然而，有音频技术专家在接受每日吃瓜采访时表示，综合分析该录音的声纹特征、环境音和语气连贯性，"90%以上可以确认并非AI合成"。

涉事明星方面至今未做任何回应。其工作室电话始终无人接听。与此同时，品牌方的天猫旗舰店评论区在24小时内涌入超过2万条差评，多为"不敢买了""要求退一赔三"等言论，品牌形象遭受重创。`,

    category: 'redianzonghe',
    author: '吃瓜前线记者',
    publishDate: '2026-06-28',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20celebrity%20at%20private%20dinner%20table%20speaking%20casually%2C%20warm%20restaurant%20lighting%2C%20candid%20moment%2C%20documentary%20style%20photography%2C%20intimate%20atmosphere%2C%20soft%20focus%20background&width=800&height=500&seq=chigua-article-006&orientation=landscape',
    imageAlt: '品牌代言人私下吐槽产品被录音',
    views: 198300,
    comments: 6340,
    tags: ['品牌代言', '录音', '律师函', '危机公关'],
    isHot: true,
    isExclusive: true,
  },
  {
    id: 'article-007',
    title: '网红情侣分手大戏：男方出轨聊天记录全曝光，女方深夜发文控诉',
    summary: '坐拥千万粉丝的网红情侣突然分手，女方深夜发布长文并附上男方出轨的聊天记录截图，引发全网热议。',
    content: `6月27日凌晨2点，在全网2000万粉丝的注视下，知名网红情侣"阿宇和小鹿"的感情以一场惊心动魄的"深夜微博大战"画上了句号。女方小鹿在微博发布了一篇长达3000字的分手长文，并附上了18张男方与多名女性的暧昧聊天记录截图，直接将这出感情大戏推向了高潮。

小鹿在长文中详细描述了她发现男方出轨的全过程。据称，今年5月，她无意间在阿宇的备用手机中发现了大量的暧昧聊天记录。聊天对象包括阿宇的一名女助理、某MCN机构的女运营，以及至少三名粉丝。聊天内容之露骨令人不忍直视，涉及大量亲密称呼和约会细节。更令人愤怒的是，其中部分聊天记录的时间显示，阿宇在向小鹿求婚的第二天晚上，就与另一名女性在酒店约会。

小鹿在文中写道："我曾经以为我遇到了那个可以共度一生的人，我们一起创业、一起拍视频、一起规划未来。但现在我才知道，在这段感情里，只有我一个人在认真。"这段文字引发了大量网友的共鸣，微博发出后一小时内转发量突破50万。

当事人阿宇在沉默了整整12个小时后，于27日下午发布了一段时长5分钟的道歉视频。视频中他面容憔悴、数度哽咽，承认了自己的出轨行为，表示"渣男没有资格求得原谅"，并宣布将退出两人共同经营的账号。但网友们并不买账，弹幕被清一色的"滚"字霸占。

目前，两人共同经营的公司和社交媒体账号面临着复杂的财产分割问题。据知情人士透露，两人虽然早已同居但并未领证，法律上属于"同居关系"而非"婚姻关系"，这可能导致女方在财产分割中处于不利地位。`,

    category: 'wanghong-black',
    author: '深度调查组',
    publishDate: '2026-06-27',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20female%20influencer%20looking%20at%20phone%20with%20shocked%20expression%20late%20at%20night%2C%20social%20media%20on%20screen%2C%20emotional%20moment%2C%20warm%20bedroom%20lighting%2C%20cinematic%20portrait%2C%20dramatic%20mood&width=800&height=500&seq=chigua-article-007&orientation=landscape',
    imageAlt: '网红情侣分手出轨聊天记录曝光',
    views: 456700,
    comments: 15890,
    tags: ['网红情侣', '出轨', '聊天记录', '分手'],
    isHot: true,
    isExclusive: false,
  },
  {
    id: 'article-008',
    title: '独家揭秘：某选秀节目冠军与经纪公司对簿公堂，合约纠纷全解析',
    summary: '选秀出道后爆红的新人王与经纪公司因合约问题闹上法庭，本台独家获取了双方的起诉状，为你解析这场娱乐圈合约大战。',
    content: `曾在某大型选秀节目中凭超高人气夺冠的新人王"林辰逸"（化名），近日正式向法院提起诉讼，要求与其签约的某知名经纪公司解除合约，一场娱乐圈典型的"新人合约陷阱"纠纷由此进入公众视野。每日吃瓜独家获取了双方提交给法院的起诉状和答辩状，为您全面解析这场合约大战。

根据林辰逸方面的起诉状，2024年3月，刚刚大学毕业的他在参加选秀比赛期间被该公司以"出道保障"为由，签订了一份为期10年的独家经纪合约。起诉状指出，这份合约存在多处不合理条款：分成比例为残酷的"艺人10%、公司90%"；公司每月仅支付5000元"基本生活费"但需要从艺人收入中抵扣；合约期间艺人几乎无权拒绝任何工作安排。

更为关键的是，林辰逸方面声称，公司在其参加选秀期间曾承诺为其制作高质量的个人专辑，但至今未兑现。选秀夺冠后的两年里，他的工作安排以"商业站台"和"直播带货"为主，几乎没有任何音乐方面的投入和发展。起诉状中写道："原告的经纪公司将其视为短期变现工具，而非一个需要长期培养的艺人。"

而被告公司则在答辩状中反驳称，公司在签约初期为林辰逸投入了大量资源，包括专业的声乐培训、舞蹈训练和形象包装，这些"前期投入"理应通过后续的分成来回收。答辩状还披露，林辰逸在夺冠后的第一年为公司创造了约3200万元的净收入，但根据合约，他本人实际到手的金额不足300万元。

目前该案已在北京市朝阳区人民法院正式立案。法律界人士分析认为，此类"经纪约陷"纠纷的核心争议在于合约的公平性。根据民法典的相关规定，如果能够证明合约存在"显失公平"的情形，法院有可能支持解除合约的请求。但经纪公司也极有可能提出巨额反诉，要求艺人赔偿"预期利益损失"。`,

    category: 'dushijubao',
    author: '内部消息人士',
    publishDate: '2026-06-27',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20young%20singer%20in%20courtroom%20setting%20with%20legal%20documents%2C%20serious%20expression%2C%20dramatic%20lighting%2C%20warm%20tones%2C%20editorial%20portrait%20style%2C%20tension%20atmosphere&width=800&height=500&seq=chigua-article-008&orientation=landscape',
    imageAlt: '选秀冠军与经纪公司合约纠纷',
    views: 167800,
    comments: 5230,
    tags: ['选秀冠军', '合约纠纷', '经纪公司', '法庭'],
    isHot: false,
    isExclusive: true,
  },
  {
    id: 'article-009',
    title: '某知名导演新片选角潜规则曝光，多位女演员实名发声',
    summary: '数位女演员集体实名发声，指控某位知名导演在选角过程中存在不正当行为，引发影视圈震动。',
    content: `一场由七位女演员集体实名发声引发的影视圈"MeToo"风暴正在持续发酵。她们共同指控某位执导过多部票房过亿电影的知名导演在选角过程中长期存在不正当行为，要求行业协会和有关部门介入调查。

据这七位女演员的联合声明，该导演利用其在行业中的绝对话语权，在选角过程中多次暗示或明示"潜规则"的存在。一位化名"小雨"的女演员在采访中描述了自己的亲身经历：去年冬天，她被安排在某酒店与该导演进行所谓的"单独试镜"。进入房间后，导演不仅没有安排任何试戏内容，反而不断要求她"放松一点""要有牺牲精神"，并暗示"之前的女主角都是这样过来的"。

另一位曾在多部热播剧中担任配角的女演员则在采访中泪洒现场。她回忆道，该导演曾通过副导演传达"想拿到这个角色，你知道该怎么做"的信息。在她明确拒绝后，不仅该角色被临时换人，她在后续的几部剧中的角色也被无故删除。她说："这个行业太畸形了，不妥协就出局，不是个别现象，而是系统性的人为设障。"

事件曝光后，该导演通过其律师发布了一份简短声明，称这些指控"纯属捏造"，并表示将通过法律途径维护名誉权。但随后的48小时内，又有多位女性影视从业者在社交平台发声，虽然没有直接指认具体人物，但纷纷表示"经历过类似的事情"。

目前，中国电影导演协会和电视剧制作协会均已发布声明，表示将对此事展开调查。相关部门的介入标志着这起事件已经从"个人爆料"升级为"行业事件"，其后续发展将对整个影视行业产生深远影响。`,

    category: 'heiliaotian',
    author: '深度调查组',
    publishDate: '2026-06-26',
    imageUrl: 'https://readdy.ai/api/search-image?query=Film%20set%20audition%20room%20with%20empty%20chairs%20and%20camera%2C%20moody%20atmosphere%2C%20dramatic%20lighting%2C%20warm%20and%20dark%20tones%2C%20cinematic%20composition%2C%20tension%20and%20mystery&width=800&height=500&seq=chigua-article-009&orientation=landscape',
    imageAlt: '知名导演选角潜规则曝光',
    views: 289400,
    comments: 9870,
    tags: ['导演', '潜规则', '女演员', '实名举报'],
    isHot: true,
    isExclusive: true,
  },
  {
    id: 'article-010',
    title: '年度最甜CP疑似假戏真做？片场亲密互动被群众演员偷拍',
    summary: '正在热播的都市爱情剧男女主角被群众演员拍到片场休息时十指紧扣散步，两人此前均否认恋情传闻。',
    content: `正在热播的都市爱情剧《余生有你》的男女主角刘宇轩（化名）和沈若溪（化名）被曝在片场休息时亲密互动，多位群众演员拍到了两人十指紧扣在片场外围散步的画面，引发外界关于两人"假戏真做"的猜测。

据提供照片的群众演员描述，当天是6月25日下午，剧组在某创意园区拍摄外景戏份。在拍摄间隙，刘宇轩和沈若溪以"对戏"为由避开大部队，在园区的一条僻静小路上散步。目击者称，两人起初只是并肩而行，但很快就牵起了手，而且不是剧中角色的那种客套牵手，而是十指紧扣的自然状态。更甜蜜的是，刘宇轩时不时低头在沈若溪耳边说些什么，惹得女方笑弯了腰。

这段视频流出后，两人的CP粉们狂欢不已。自从《余生有你》开播以来，"轩溪CP"就一直是热搜常客。剧中两人饰演一对经历重重磨难最终走到一起的恋人，戏里的化学反应已经让观众嗑到上头，如果戏外也是真情侣，简直堪称年度最甜售后。

然而，面对外界的追问，双方团队的态度颇为耐人寻味。刘宇轩工作室的回应是"请关注作品，勿过度解读私下互动"，既没有承认也没有否认；而沈若溪方面则以"纯属剧组同事之间的正常相处"来回应。这种含糊其辞的官方回应，在吃瓜经验丰富的老网友看来，反而更像是默认的暗号。

圈内人士分析，两人如果真在一起，选择不公开也情有可原。刘宇轩和沈若溪目前都处于事业上升期，公开恋情可能会影响各自的商业价值。尤其是双方都签有价值不菲的品牌代言合约，其中通常包含"维持良好公众形象"的条款，公开恋情可能触发相关限制。`,

    category: 'star-gossip',
    author: '吃瓜前线记者',
    publishDate: '2026-06-26',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20actor%20and%20actress%20holding%20hands%20on%20drama%20film%20set%20during%20break%2C%20romantic%20atmosphere%2C%20warm%20sunset%20lighting%2C%20behind%20the%20scenes%20candid%20moment%2C%20soft%20focus%2C%20cinematic%20style&width=800&height=500&seq=chigua-article-010&orientation=landscape',
    imageAlt: '最甜CP片场亲密互动被偷拍',
    views: 234500,
    comments: 7890,
    tags: ['CP', '假戏真做', '片场', '恋情'],
    isHot: false,
    isExclusive: false,
  },
  {
    id: 'article-011',
    title: '知名音乐人被前员工爆料偷税漏税，税务部门已介入调查',
    summary: '一位自称某知名音乐人前员工的网友在社交平台公开举报其偷税漏税，并附上部分账目截图，目前税务部门已表示关注此事。',
    content: `6月25日晚，一个名为"打工人不再沉默"的新注册账号在微博发布了一篇详尽的长文，以实名方式举报某位在华语乐坛具有重要地位的知名音乐制作人长期通过阴阳合同、虚假成本等方式偷逃巨额税款，并附上了多张疑似内部账目的截图作为证据。

举报人自称是该音乐人工作室的前财务人员，于今年3月被无故辞退。根据他提供的账目材料，这位音乐人及其工作室在过去三年内通过多种方式隐瞒真实收入：一是将部分音乐版权收入拆分至多个空壳公司账户；二是将个人消费（包括豪车购买、家庭装修等）以"制作成本""宣传费用"等名义在工作室账目中抵扣；三是与部分合作方签订"阴阳合同"，以远低于实际金额的合同向税务机关申报。

举报材料中最令人瞠目的是一份2025年度的内部账目汇总表。该表格显示，该音乐人当年仅音乐版权、制作费、综艺出场费等项目的税后实际收入就超过了6000万元，但向税务机关申报的收入仅为800余万元，差距高达七倍之多。

税务部门对此次公开举报反应迅速。26日上午，国家税务总局在其官方微博上发布了一条简短的声明："已注意到相关网络举报，将依法依规进行核实调查。"据税务领域专业人士分析，如果举报内容查证属实，该音乐人将面临补缴税款、加收滞纳金以及巨额罚款，严重情况下甚至可能被追究刑事责任。

涉事音乐人方面在事件发酵两天后终于打破沉默，通过律师发布声明称举报内容"存在大量失实和断章取义之处"，并表示将积极配合调查。但其工作室的官方账号评论区已被网友攻陷，大量留言呼吁"依法严查""明星不是法外之地"。`,

    category: 'redianzonghe',
    author: '深度调查组',
    publishDate: '2026-06-25',
    imageUrl: 'https://readdy.ai/api/search-image?query=Music%20studio%20with%20financial%20documents%20on%20table%2C%20serious%20atmosphere%2C%20warm%20indoor%20lighting%2C%20investigative%20journalism%20style%2C%20moody%20tones%2C%20dramatic%20composition&width=800&height=500&seq=chigua-article-011&orientation=landscape',
    imageAlt: '知名音乐人被举报偷税漏税',
    views: 178900,
    comments: 6120,
    tags: ['音乐人', '偷税漏税', '举报', '税务'],
    isHot: false,
    isExclusive: true,
  },
  {
    id: 'article-012',
    title: '某流量小生被曝学历造假，经纪公司紧急发声明否认',
    summary: '有网友通过学信网查询发现某流量小生的学历信息与公开宣传不符，质疑其学历造假。经纪公司火速发声明称系"信息录入错误"。',
    content: `6月25日，一则关于某当红流量小生学历造假的帖子在豆瓣小组引发轩然大波。发帖网友声称通过中国高等教育学生信息网（学信网）查询发现，该艺人公开宣传的"北京电影学院表演系本科"学历无法在系统中查到对应记录，其真实的最高学历仅为某民办艺校的大专。

该帖一出，迅速在各大社交平台扩散。网友们开始翻找该艺人过往的所有采访和综艺片段，发现他曾在至少四档节目中明确提到自己的"北电本科"身份，甚至在一次演讲类综艺中详细描述了"在北电四年的学习时光"，细节之丰富令人咋舌。如果学历信息属实为造假，那么这些"回忆"将全部成为精心编织的谎言。

面对愈演愈烈的质疑，该艺人所属经纪公司在事件发酵约8小时后火速发布了一份声明。声明中承认该艺人的确存在"学历信息不一致"的情况，但解释称这是因为"早年官方资料中存在信息录入错误"，公司在入职时未及时发现和更正。声明最后强调该艺人"从未在任何场合主动宣称自己拥有北电本科学历"——然而这一说法与网友扒出的多段视频证据形成了明显矛盾。

教育圈和娱乐圈的双重观察者"李老师"在接受每日吃瓜采访时分析道："学历造假在娱乐圈并非个例，背后折射的是整个行业对'精英人设'的病态追求。好像不是名校毕业、没有留学背景就不配做艺人似的。其实观众真正在意的是演技和作品，而不是艺人毕业证上印的是哪个学校的名字。"`,

    category: 'heiliaotian',
    author: '吃瓜前线记者',
    publishDate: '2026-06-25',
    imageUrl: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20male%20celebrity%20looking%20worried%20at%20press%20conference%2C%20dramatic%20lighting%2C%20warm%20tones%2C%20media%20event%20atmosphere%2C%20editorial%20photography%20style%2C%20tension%20mood&width=800&height=500&seq=chigua-article-012&orientation=landscape',
    imageAlt: '流量小生被曝学历造假',
    views: 201400,
    comments: 7340,
    tags: ['流量小生', '学历造假', '声明', '学信网'],
    isHot: false,
    isExclusive: false,
  },
  {
    id: 'article-013',
    title: '某女星被拍到深夜出入整形医院，经纪人称只是"做皮肤护理"',
    summary: '有网友拍到某当红女星深夜独自出入知名整形医院，面部包裹严实。经纪人紧急回应称只是常规皮肤护理，但网友扒出该医院以整形手术闻名。',
    content: `6月23日晚间，有网友在上海市静安区某知名医美机构门口拍到了一位当红女星的身影。照片中的她身穿宽大的黑色卫衣，头戴渔夫帽和口罩，面部几乎完全被遮挡，正在快速从医院侧门走出并钻进等候在门口的保姆车。尽管遮挡严密，但网友通过其标志性的身材和保姆车的车牌号确认了其身份。

照片被上传到社交媒体后，细心的网友们迅速扒出了这家医疗机构的信息。令人起疑的是，这并非一家普通的皮肤管理机构，而是上海业内颇有名气的整形美容专科医院，以面部轮廓手术和鼻部整形最为出名。该医院的官网上明确写着："专注面部整形美容15年，服务超过10万例求美者"——这与普通的"皮肤护理"相去甚远。

更引人关注的是，这已经是该女星三个月内第三次被拍到出入这家医院。有网友整理了时间线：4月初她第一次被拍到进入该医院，当时面部有明显肿胀痕迹；5月中旬第二次出现时，面部轮廓似乎有了微妙变化；而这次的"深夜造访"则被怀疑是术后复查或微调。

经纪人的回应也颇为经典——"只是常规皮肤护理，请大家不要过分解读。"但这一说法很快被业内人士打脸，一位在该医院附近工作的医美顾问匿名向每日吃瓜透露："那个时间段（晚上9点后）皮肤科早就下班了，能看的只有整形外科的预约。"

网友对此事的评论分成两派：一派认为"爱美之心人皆有之，整容也没什么大不了"；另一派则批评该女星"一边营销天然美女的人设，一边偷偷动脸，太假了"。无论如何，这件事再次证明了一个真理——在娱乐圈，越是拼命捂的事情，越是捂不住。`,

    category: 'star-gossip',
    author: '吃瓜前线记者',
    publishDate: '2026-06-24',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20female%20celebrity%20walking%20out%20of%20cosmetic%20surgery%20clinic%20at%20night%20with%20face%20covered%2C%20warm%20street%20lights%2C%20paparazzi%20style%2C%20mysterious%20atmosphere%2C%20editorial%20magazine%20aesthetic%2C%20dramatic%20lighting%2C%20cinematic%20mood&width=800&height=500&seq=chigua-article-013&orientation=landscape',
    imageAlt: '女星深夜出入整形医院被拍',
    views: 345600,
    comments: 12580,
    tags: ['女星', '整形', '整容', '医院'],
    isHot: true,
    isExclusive: true,
  },
  {
    id: 'article-014',
    title: '双顶流被曝已秘密领证？两人同款戒指和行程细节被扒出',
    summary: '网友扒出两位顶流艺人近半年来多次佩戴同款情侣戒指，且行程高度重合，更有知情人士爆料两人已在海外秘密领证。',
    content: `一场由"戒指"引发的顶流婚恋猜想正在全网蔓延。两位在各自领域都处于金字塔尖位置的顶流艺人——歌手"暗光"和演员"盛夏"——被网友们发现近半年来多次佩戴同款戒指，两人的行程也被扒出惊人重合，更有圈内知情人士向每日吃瓜爆料称两人其实已在海外秘密领证。

戒指是这出"探案大戏"的起点。最早是一位粉丝在整理两人的公开活动照片时，发现暗光在去年12月的跨年演唱会上右手无名指戴了一枚设计独特的铂金戒指。而这枚戒指与盛夏在今年1月参加某颁奖典礼时左手无名指上佩戴的戒指几乎完全一致——同样的品牌、同样的系列、甚至刻字的位置都一模一样。该品牌为某法国高奢珠宝品牌，该系列主打"一生只送一人"的定制婚戒概念，每一对戒指都是独一无二的。

戒指之外，两人的行程也存在着大量"巧合"。有网友制作了一张详细的对比表格：过去8个月里，两人至少有12次同时出现在不同城市的同一个高档酒店；在海外度假时，两人发布的社交媒体照片背景被扒出是同一个度假村；甚至有外卖骑手在论坛爆料，称曾给某明星送外卖时，在房间门口看到了另一位明星的行李箱。

面对铺天盖地的猜测，双方工作室至今保持沉默。暗光最近一次接受采访时被记者旁敲侧击问及感情状况，他笑了笑说："有好消息一定会告诉大家。"这个意味深长的回答被粉丝们解读为默认。而盛夏则在一档综艺节目中无意间说漏嘴，称呼某人为"我们家那位"，随后迅速改口但为时已晚。

多位娱乐圈资深经纪人向每日吃瓜表示，近年来选择"隐婚"的顶级艺人越来越多。背后的逻辑很简单：一旦公开婚讯，不仅会影响"女友粉""男友粉"的忠诚度，还可能与品牌代言合约中的"单身人设"条款产生冲突。对于顶流而言，婚姻不仅是感情问题，更是商业问题。`,

    category: 'star-gossip',
    author: '深度调查组',
    publishDate: '2026-06-23',
    imageUrl: 'https://readdy.ai/api/search-image?query=Two%20matching%20luxury%20rings%20on%20a%20velvet%20surface%20under%20warm%20romantic%20lighting%2C%20elegant%20jewelry%20photography%2C%20mysterious%20and%20intimate%20atmosphere%2C%20soft%20focus%2C%20editorial%20magazine%20style%2C%20warm%20golden%20tones&width=800&height=500&seq=chigua-article-014&orientation=landscape',
    imageAlt: '双顶流同款戒指细节被扒',
    views: 567800,
    comments: 23450,
    tags: ['顶流', '领证', '戒指', '隐婚'],
    isHot: true,
    isExclusive: true,
  },
  {
    id: 'article-015',
    title: '百万粉丝美食博主被曝后厨全是预制菜，人设崩塌粉丝集体脱粉',
    summary: '一位以"手工制作"著称的美食博主被前员工曝光，其视频中展示的所有菜品均使用预制菜包加热完成，所谓的"秘制配方"全是谎言。',
    content: `在短视频平台拥有超过380万粉丝的知名美食博主"厨娘小满"近日遭遇了其自媒体生涯以来最大的一次人设崩塌。一位自称其前助理的网友发布了一段长达20分钟的爆料视频，彻底揭开了这位"手工美食达人"的真实后厨面貌。

爆料视频中可以看到，小满视频里那些看起来色香味俱全的"手工秘制"菜品，实际上全部来自各大预制菜供应商的标准化产品。视频展示了小满工作室后厨的冷柜中整齐码放的数百包预制菜包——红烧肉、糖醋排骨、麻辣香锅、酸菜鱼，应有尽有。前助理在视频中讽刺道："她视频里说的'小火慢炖三小时'，其实就是微波炉加热三分钟。那些所谓的'独家配方'，在淘宝上19块9能买三包。"

更令人震惊的是，前助理还披露了小满视频的拍摄流程：所有菜品都是提前加热好的预制菜，只是在镜头前摆个样子。那些看起来像是"中途加料""翻炒"的镜头，实际上是对着已经做好的菜反复拍摄。"你们看到她在厨房里忙活一个小时，其实人家全程就站着摆拍。真正的'厨艺'就是把预制菜包装拆得好看一点。"

视频发布48小时内，小满的粉丝数骤降超过50万，评论区被愤怒的粉丝攻陷。大量曾经的铁粉晒出自己按照小满的"配方"购买食材的订单截图，有人甚至花了上千元去复刻她的"秘制东坡肉"，才知道自己中了一个精心设计的圈套。

小满在沉默三天后发布了一段道歉视频，但这段道歉被网友们吐槽为"教科书级的翻车道歉"——全程没有正面回应预制菜问题，只是反复强调"做内容不容易""希望大家多给一点包容"。这种避重就轻的态度让脱粉潮更加猛烈，其合作的三个食品品牌也在事件后火速解除了代言合约。`,

    category: 'wanghong-black',
    author: '内部消息人士',
    publishDate: '2026-06-24',
    imageUrl: 'https://readdy.ai/api/search-image?query=Messy%20restaurant%20kitchen%20with%20packaged%20pre-made%20meal%20boxes%20on%20counter%2C%20chaotic%20behind%20the%20scenes%2C%20warm%20fluorescent%20lighting%2C%20documentary%20photography%20style%2C%20investigative%20journalism%20mood%2C%20dramatic%20atmosphere&width=800&height=500&seq=chigua-article-015&orientation=landscape',
    imageAlt: '美食博主后厨预制菜曝光',
    views: 423100,
    comments: 18760,
    tags: ['美食博主', '预制菜', '人设崩塌', '脱粉'],
    isHot: true,
    isExclusive: true,
  },
  {
    id: 'article-016',
    title: '知名游戏主播代打实锤！直播间露出手柄操作与画面不同步',
    summary: '观众在慢放直播录像时发现，某知名游戏主播的手柄操作与画面存在明显不同步，疑似使用代打团队。主播至今未做回应。',
    content: `游戏直播圈一场"代打门"风波正在持续升温。在某直播平台拥有超过600万粉丝的头部游戏主播"风神"，被观众通过逐帧慢放技术发现其直播时的手柄操作与游戏画面存在约0.3秒的延迟不同步，这被视为"代打"的典型特征。

这场揭露行动始于6月22日深夜。一位网名为"正义之眼"的观众在观看风神的直播回放时，注意到一个微妙的细节：当风神操作角色做出一个极高难度的连续格挡动作时，他手上按动手柄的动作与屏幕上角色的动作明显不同步——手柄按键按下去之后，画面中的动作晚了一小拍才跟上。这个时间差虽然不到半秒，但在高水平的格斗游戏中已足以被察觉。

"正义之眼"随后制作了一期详细的逐帧分析视频，将风神多场直播中"手柄与画面"的同步性进行了专业对比。在对比画面中，可以清晰地看到：在一些高难度连招的片段里，风神的手明明在做简单的推摇杆动作，但屏幕上的角色却精准地执行了一套极其复杂的连招——这种"手低画高"的落差，是代打的铁证。

更令人震惊的是，"正义之眼"进一步调查发现，风神直播时的摄像头角度似乎经过了精心设计——永远只能看到他的上半身和双手，但看不到双脚以下的区域。这一发现让代打的方式浮出水面：极有可能是一名真正的高手藏在摄像头盲区中，同一个房间内使用第二个手柄进行实际操作。

风波越演越烈，但风神本人和其团队始终未做任何回应。其直播间虽然仍在正常直播，但弹幕已被清一色的"代打""出来回应"霸占。平台方面也尚未对此事做出官方表态。多位业内人士分析，如果代打一事查实，风神不仅将面临粉丝基础崩塌，还可能因商业欺诈被合作的品牌方集体索赔。`,

    category: 'wanghong-black',
    author: '深度调查组',
    publishDate: '2026-06-23',
    imageUrl: 'https://readdy.ai/api/search-image?query=Gaming%20setup%20with%20controller%20and%20monitor%20showing%20gameplay%20mismatch%2C%20dramatic%20lighting%2C%20warm%20gaming%20room%20atmosphere%2C%20investigative%20documentary%20style%2C%20tension%20and%20mystery%20mood%2C%20dark%20tones%20with%20screen%20glow&width=800&height=500&seq=chigua-article-016&orientation=landscape',
    imageAlt: '游戏主播代打被观众实锤',
    views: 289300,
    comments: 9870,
    tags: ['游戏主播', '代打', '实锤', '直播'],
    isHot: false,
    isExclusive: true,
  },
  {
    id: 'article-017',
    title: '独家：某影视公司老板被拍到与多名女艺人同游海外，照片流出',
    summary: '某知名影视公司老板被拍到与旗下三位女艺人同游马尔代夫，照片中行为亲密。多位圈内人表示此事在业内并非秘密。',
    content: `一组在马尔代夫某奢华私人岛屿度假村拍摄的照片近日在娱乐圈内部流传开来，照片主角为某知名影视公司老板周某及其旗下三位签约女艺人。照片中四人在沙滩上亲密合影，周某更是左拥右抱，行为尺度之大令人瞠目。

据每日吃瓜独家获悉，这次马尔代夫之旅发生在6月中旬，为期一周，全程入住该度假村最顶级的总统别墅，每晚房价高达3万元。整个行程的所有费用均由周某个人承担。三位同行的女艺人分别是公司去年签下的新人演员，年龄均在22至25岁之间，目前都处于"被公司力捧"的阶段，资源好到令同行艳羡。

圈内知情人向每日吃瓜透露，在这次的马尔代夫行程之前，类似的"老板带女艺人出游"已经不是第一次发生了。去年春节，周某曾带两位女艺人在三亚某高尔夫度假村度过了一周；今年4月，又有两人随周某一同前往日本京都赏樱。该知情人直言："这种情况在公司内部根本不是什么秘密，大家心照不宣而已。谁被老板带出去的次数多，谁的资源就好，这几乎成了一种不成文的规则。"

事件曝光后，引发了关于"娱乐行业权力不对等"的广泛讨论。有媒体评论人指出，在老板面前，这些刚入行的年轻女艺人几乎没有说不的能力——拒绝老板的"好意"可能意味着被雪藏，而接受则意味着陷入不健康的关系之中。这种结构性的权力失衡，是娱乐圈长久以来的顽疾。

目前涉事公司未对此事做出任何回应。三位女艺人的社交媒体账号自事件曝光后全部停止了更新，仿佛人间蒸发。每日吃瓜尝试联系该公司公关部门，电话始终无人接听。`,

    category: 'dushijubao',
    author: '内部消息人士',
    publishDate: '2026-06-24',
    imageUrl: 'https://readdy.ai/api/search-image?query=Luxury%20tropical%20resort%20beach%20scene%20with%20silhouettes%20of%20people%20at%20sunset%2C%20Maldives%20style%20overwater%20villas%2C%20warm%20golden%20hour%20lighting%2C%20mysterious%20and%20dramatic%20atmosphere%2C%20paparazzi%20long%20distance%20shot%20style%2C%20editorial%20magazine%20aesthetic&width=800&height=500&seq=chigua-article-017&orientation=landscape',
    imageAlt: '影视公司老板与女艺人同游海外',
    views: 412700,
    comments: 15620,
    tags: ['影视公司', '老板', '女艺人', '海外游'],
    isHot: true,
    isExclusive: true,
  },
  {
    id: 'article-018',
    title: '某歌手新专辑疑似抄袭海外作品，网友逐帧对比相似度高达80%',
    summary: '有网友将某当红歌手的新专辑主打歌与一首海外小众歌曲进行逐帧对比，发现旋律、编曲和MV构图高度相似。粉丝与网友激烈争论。',
    content: `音乐圈又现"抄袭"争议。6月21日，一段由B站音乐区UP主制作的对比视频将某当红歌手刚发布一周的新专辑主打歌《微光》推上了风口浪尖。视频通过专业音频软件将《微光》与一首2024年发行的法国独立音乐人作品《Lueur》进行逐帧对比，发现两首歌在主旋律、副歌和桥段部分高度相似。

对比视频显示，《微光》的主旋律与《Lueur》在前8个小节中几乎完全一致，仅在最后两个音符上做了半音升高的处理。副歌部分的旋律走向和和弦进行更是如出一辙，连伴奏中电子音色的选用都十分接近。UP主在视频中评论道："这不是'灵感借鉴'的范畴，这是Ctrl+C然后稍微改了一下的程度。"

除了音乐的相似性之外，MV的画面也被网友扒出了多处"雷同"。《微光》MV中几个极具辨识度的镜头——歌手站在废旧工厂中、透过破碎的玻璃窗向外凝望、在水池倒影中看到另一个自己——与《Lueur》的MV构图高度重合。尽管两者的色调和美术风格有所不同，但分镜逻辑的相似性让"巧合"的解释显得苍白无力。

事件迅速在国际音乐社区引发关注。《Lueur》的原创作者在得知此事后在社交媒体上发表了一条含蓄的推文："Imitation is the sincerest form of flattery, but credit would be nice.（模仿是最真诚的恭维，但注明出处会更好。）"虽然未直接点名，但其发布的时间点和内容指向性已经不言而喻。

面对质疑，涉事歌手及其制作团队选择了冷处理，至今未发布任何官方声明。其粉丝群体则分裂为两个阵营：一派坚持认为"相似不等于抄袭，这是常见的流行和弦进行"；另一派则理性地表示"如果真的借鉴了，大方承认并补上版权声明才是正确的做法"。

这场争议再次将华语乐坛的版权问题推到了聚光灯下。多位资深音乐人指出，在流媒体时代，跨国音乐借鉴的边界越来越模糊，但核心原则始终不变——尊重原创、敬畏创作。`,

    category: 'dushijubao',
    author: '深度调查组',
    publishDate: '2026-06-22',
    imageUrl: 'https://readdy.ai/api/search-image?query=Music%20recording%20studio%20with%20sheet%20music%20spread%20on%20table%20under%20warm%20lighting%2C%20creative%20and%20dramatic%20atmosphere%2C%20documentary%20photography%20style%2C%20tension%20between%20originality%20and%20inspiration%2C%20moody%20editorial%20tones&width=800&height=500&seq=chigua-article-018&orientation=landscape',
    imageAlt: '歌手新专辑疑似抄袭对比',
    views: 278900,
    comments: 11230,
    tags: ['歌手', '专辑', '抄袭', '对比'],
    isHot: false,
    isExclusive: true,
  },
  {
    id: 'article-019',
    title: '知名经纪人被曝私吞艺人片酬，多位明星已解约并提起诉讼',
    summary: '某娱乐圈金牌经纪人被旗下多位艺人联名举报，指控其通过阴阳合同私吞艺人片酬，涉及金额或达上亿元，目前已有多位明星宣布解约。',
    content: `娱乐圈又爆出一起堪称地震级别的经纪人丑闻。在圈内素有"铁腕经纪人"之称的王某，被其旗下五位艺人联名举报，指控其利用阴阳合同、虚假账目等手段系统性侵吞艺人片酬和商业收入，涉案金额据保守估计已超过1.2亿元。

联合举报的五位艺人中，既有出道超过15年的一线实力派演员，也有近两年迅速蹿红的新生代偶像。他们在联名举报信中详细列出王某的多项"罪状"：一是通过签订阴阳合同，将实际片酬与向艺人报备的金额之间的差额据为己有；二是以"公司运营成本"的名义克扣艺人收入；三是在商业代言合作中私自收取品牌方的"返点"而不告知艺人。

举报信中最触目惊心的一项指控是：某位艺人2024年拍摄的一部电视剧，实际签约片酬为2800万元，但王某向该艺人告知的金额仅为1200万元，中间的1600万元差额全部进了王某的个人账户。当该艺人无意间从剧组工作人员口中得知真实片酬后，王某不仅拒绝退还差额，反而以"行业内都这样操作"为由威胁艺人不要声张。

目前，五位艺人已集体解除与王某的经纪合约，并向北京市朝阳区人民法院提起了民事诉讼。与此同时，中国演出行业协会也发布声明，表示已注意到该事件并启动行业调查程序。一旦查实，王某不仅将面临民事赔偿和行政处罚，还可能因涉嫌职务侵占罪被追究刑事责任。

王某本人至今未公开露面。其律师在接受媒体采访时表示"相关指控与事实严重不符"，但拒绝就具体指控做出回应。有意思的是，在事件爆发后不到48小时，又有三位曾经与王某合作的艺人通过不同渠道发声，表示自己也"可能在不知情的情况下被侵吞了收入"。这场风暴，似乎才刚刚开始。`,

    category: 'heiliaotian',
    author: '深度调查组',
    publishDate: '2026-06-24',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20office%20desk%20with%20legal%20documents%20and%20contracts%20scattered%20under%20dramatic%20warm%20lighting%2C%20serious%20business%20atmosphere%2C%20investigative%20journalism%20style%2C%20tension%20and%20betrayal%20mood%2C%20dark%20editorial%20tones&width=800&height=500&seq=chigua-article-019&orientation=landscape',
    imageAlt: '经纪人私吞艺人片酬被举报',
    views: 389500,
    comments: 14280,
    tags: ['经纪人', '片酬', '阴阳合同', '解约'],
    isHot: true,
    isExclusive: true,
  },
  {
    id: 'article-020',
    title: '音乐节后台明星互动大揭秘：谁在抱团取暖，谁在独来独往',
    summary: '本年度最大音乐节后台花絮全记录。多位艺人台上台下判若两人，有人三五成群热聊不断，有人独自刷手机全程零社交。',
    content: `上周末举办的"麦浪音乐节"汇聚了超过30组华语音乐人，而每日吃瓜的后台观察员全程潜伏在艺人休息区，为你带来最真实的后台"社交生态"全记录。

首先要说的是"社交达人"组的代表——说唱歌手KK。KK在后台简直是行走的"人脉枢纽"，从民谣歌手到摇滚乐队，从流行天后到独立新人，他似乎认识所有人。观察员统计，在三个小时的候场时间里，KK主动串场拜访了至少12组艺人，每一次都是热情拥抱加长时间热聊，被一旁的工作人员私下戏称为"后台社交天花板"。

与之形成鲜明对比的是某位以"高冷"著称的独立女歌手。整个候场期间，她几乎全程坐在自己休息室的角落里戴着耳机刷手机，连工作人员送餐都只是点头示意没有言语交流。期间有两位其他艺人礼貌性地敲门想要打招呼，都被她的助理以"正在备场"为由婉拒了。这位女歌手上台后却是另一种状态——和观众互动频繁、笑容满面，判若两人。

另外一组值得关注的是"抱团取暖"的新人区。几位近两年刚崭露头角的年轻歌手自发聚集在了一个共用休息区，交流着各自的演出心得和行业八卦。一位新人歌手对同伴感慨："平时大家都是微信上聊天，真的见面还是感觉不一样。"这种同期生之间的惺惺相惜，成为了后台最温暖的一道风景。

不过也有一些令人尴尬的时刻。某乐队主唱被看到在走廊上偶遇前女友——一位同场表演的女歌手——两人对视了不到一秒便各自迅速扭头走开，整个走廊的空气仿佛凝固了。据知情人透露，两人去年分手时闹得很不愉快，没想到音乐节竟然把两人排在了同一个时段候场，真是冤家路窄。`,

    category: 'yulebagua',
    author: '后台观察员',
    publishDate: '2026-06-24',
    imageUrl: 'https://readdy.ai/api/search-image?query=Music%20festival%20backstage%20area%20with%20Chinese%20performers%20in%20casual%20outfits%20mingling%2C%20warm%20atmosphere%20with%20colorful%20stage%20lights%2C%20documentary%20candid%20photography%2C%20vibrant%20yet%20editorial%20style%2C%20dynamic%20composition&width=800&height=500&seq=chigua-article-020&orientation=landscape',
    imageAlt: '音乐节后台明星互动大揭秘',
    views: 198700,
    comments: 6780,
    tags: ['音乐节', '后台', '明星互动', '社交'],
    isHot: false,
    isExclusive: false,
  },
  {
    id: 'article-021',
    title: '某剧组盒饭事件升级：一线演员开小灶吃火锅，群演蹲路边吃盒饭',
    summary: '某大制作剧组被爆出严重区别对待演职人员。一线主演每天有专人送火锅和私厨菜，而百余名群演只能蹲在路边吃冷掉的盒饭。',
    content: `一张在社交媒体上疯传的照片揭开了影视剧组内部严重不平等的冰山一角。照片中，某大制作古装剧的百余名群众演员正蹲在片场外围的马路牙子上吃着已经凉透的盒饭，而与此同时，该剧的一线主演正在专门的空调帐篷里享用由私人厨师现场烹制的火锅。

这张对比强烈的照片由剧组一位不愿具名的场务人员提供。据他描述，该剧组的伙食标准分为明确的四个等级：S级为主演专属，每天由私厨根据口味定制，火锅、刺身、牛排应有尽有，单日餐标不低于2000元；A级为主要配角，与主演同在一个帐篷用餐，菜品略逊但也是现炒热菜；B级为剧组技术人员，吃的是跟组厨师做的大锅菜；而最底层的C级——群演和临时工——领到的则是提前几个小时做好、送到片场时已经完全冷掉的统一盒饭。

"大夏天三十几度，盒饭在运输车上闷了两个多小时才送到，里面的肉都有味道了。"该场务人员在采访中愤慨地说，"群演一天才挣一百来块钱，很多人中午根本不敢吃剧组的饭，怕吃坏肚子耽误拍摄，只能自己去小卖部买面包对付一下。"

事件曝光后，该剧的制片人在社交媒体上发表了一份道歉声明，称将"立即整改剧组的餐饮管理制度"，并为全体演职人员统一提高餐标。但这份道歉并未平息争议，反而引来了更多业内人士的爆料。多位曾经在不同剧组工作的群演和场务纷纷发声，表示"这种情况在全行业普遍存在，只不过这次被拍到了而已"。

中国广播电视社会组织联合会导演委员会的一位理事在接受采访时表示，剧组的"伙食等级制"折射出整个行业对基层从业人员的严重不尊重，呼吁建立统一的行业供餐标准，从制度层面解决这一顽疾。`,

    category: 'yulebagua',
    author: '吃瓜前线记者',
    publishDate: '2026-06-23',
    imageUrl: 'https://readdy.ai/api/search-image?query=Contrast%20between%20luxury%20hotpot%20meal%20and%20simple%20boxed%20meal%20on%20Chinese%20film%20set%2C%20warm%20dramatic%20lighting%2C%20social%20inequality%20documentary%20style%2C%20editorial%20photography%2C%20powerful%20visual%20storytelling%2C%20cinematic%20composition&width=800&height=500&seq=chigua-article-021&orientation=landscape',
    imageAlt: '剧组盒饭事件一线演员与群演待遇差距',
    views: 321400,
    comments: 14560,
    tags: ['剧组', '盒饭', '区别对待', '群演'],
    isHot: true,
    isExclusive: false,
  },
  {
    id: 'article-022',
    title: '粉丝应援乱象：某偶像生日集资超千万引争议，后援会账目被质疑',
    summary: '某偶像生日应援活动集资总额突破千万大关，引发社会广泛关注。随后有粉丝质疑后援会账目不透明，部分资金去向不明。',
    content: `一场以"为偶像庆生"为名的粉丝集资活动，最终以内部信任崩塌和大量粉丝退款收场。某当红偶像的官方粉丝后援会在6月发起的生日应援集资，不到两周时间便突破了1000万元大关，创下了该粉圈的历史纪录。然而，当后援会公布的支出明细公之于众后，质疑声便如排山倒海般袭来。

根据后援会最初公布的预算方案，这1000余万元的资金将用于：18个城市核心商圈的LED大屏庆生广告（预算约300万）、包下某国际机场到达厅的全部广告位三天（预算约150万）、在某海岛为偶像举办一场私人烟花秀（预算约200万）、以及定制一份价值不菲的生日礼物——某奢侈品牌的全球限量腕表（预算约200万）。余下资金则用作"运营储备金"。

然而当后援会公布实际的支出明细时，粉丝们发现多笔支出存在严重猫腻。一份号称花费120万元在某一线城市核心商圈投放的LED大屏广告，实际投放的却是偏离核心区的三四块社区屏；那块号称"全球限量20只"的定制腕表，被懂行的粉丝扒出实际市场价不到30万元，但后援会报账的价格却是95万元；至于海岛烟花秀，至今没有任何影像资料证明其真实发生过。

面对质疑，后援会管理层的解释前后矛盾，且拒绝公开完整的财务流水记录。一位粉丝在退款申请中绝望地写道："我们省吃俭用攒下来的钱，是想要给哥哥最好的生日礼物，不是给后援会买房的。"

目前已有超过3000名参与集资的粉丝联名要求后援会公开全部财务记录并退还差额。中国消费者协会也注意到了这起事件，在其社交媒体平台上发布了一条提醒："粉丝应援属于民事赠与行为，参与者应当警惕集资风险，保留好相关凭证。"`,

    category: 'yulebagua',
    author: '深度调查组',
    publishDate: '2026-06-22',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20fan%20support%20event%20with%20birthday%20banners%20and%20luxury%20gifts%20display%2C%20warm%20festival%20atmosphere%2C%20documentary%20photography%20style%2C%20consumer%20culture%20critique%2C%20editorial%20mood%2C%20vibrant%20yet%20thought-provoking%20composition&width=800&height=500&seq=chigua-article-022&orientation=landscape',
    imageAlt: '偶像生日集资超千万引争议',
    views: 276500,
    comments: 11230,
    tags: ['粉丝', '应援', '集资', '后援会'],
    isHot: false,
    isExclusive: false,
  },
  {
    id: 'article-023',
    title: '冯小刚新片发布会火药味十足，被问及票房压力当场黑脸',
    summary: '著名导演冯小刚在新片发布会上被记者追问票房预期时明显不悦，反问记者"你买票了吗"，现场一度十分尴尬。',
    content: `6月24日上午，著名导演冯小刚携新片《尘烟往事》在北京举办了首次媒体发布会。然而，这场原定为"轻松交流"的发布会却因为记者一个关于票房预期的问题，演变成了一场充满火药味的对峙，让在场的百余家媒体记者见证了这位名导的"暴脾气"。

一切转折发生在一名影视财经类媒体记者的提问环节。该记者在提问完电影创作相关的问题后，补充问道："冯导，我们知道《尘烟往事》是一部偏文艺气质的电影，但同时它的投资规模接近2亿元。想请教一下您对票房的预期，以及片方是否对票房有一定压力？"

话音刚落，冯小刚脸上的笑容就凝固了。他先是沉默了几秒，然后反问道："你买票了吗？"记者一愣，回答说还没有。冯小刚随即提高了音量继续说："你连票都没买，就来问我票房压力？现在的记者都是这么跑会的？要不你先去把票买了，我再回答你的问题？"现场气氛瞬间降至冰点。

台下的记者们面面相觑，发布会的主持人赶紧打圆场，试图将话题引回电影本身。但冯小刚的情绪显然已经被点燃，他在后续的回答中多次夹枪带棒地影射"现在有些媒体只关心钱不关心电影"，甚至说出了"中国电影就是被你们这些写票房文章的记者毁掉的"这样极端的言论。

这段视频被传到网上后，舆论迅速分裂。一部分网友力挺冯小刚，认为记者的问题确实不合时宜："文艺片问什么票房，这不是找骂吗？"但更多的声音则批评冯小刚的态度过于蛮横："观众花了钱进电影院，关心票房怎么了？票房不好说明观众不买账，不反思自己反而骂记者，典型的甩锅。"`,

    category: 'redianzonghe',
    author: '吃瓜前线记者',
    publishDate: '2026-06-24',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20film%20director%20at%20press%20conference%20looking%20displeased%20under%20warm%20stage%20lighting%2C%20tense%20atmosphere%20with%20journalists%2C%20dramatic%20editorial%20photography%2C%20cinema%20promotion%20event%2C%20moody%20and%20confrontational%20mood&width=800&height=500&seq=chigua-article-023&orientation=landscape',
    imageAlt: '冯小刚新片发布会火药味十足',
    views: 267800,
    comments: 9870,
    tags: ['导演', '发布会', '票房', '记者'],
    isHot: false,
    isExclusive: false,
  },
  {
    id: 'article-024',
    title: '短剧演员日薪暴涨50倍！揭秘小程序短剧背后的暴利产业链',
    summary: '随着小程序短剧的爆火，短剧演员的日薪从几百元飙升至数万元。本台深入调查了这条隐藏在短视频平台背后的暴利产业链。',
    content: `如果你还以为短剧演员是"挣辛苦钱"的低端工种，那你一定不知道这个行业正在经历怎样的疯狂。每日吃瓜深入调查发现，随着小程序短剧（又称"竖屏短剧"）在过去两年间的爆发式增长，短剧演员的日薪已经从2023年的300元至500元，飙升至现在的1.5万元至3万元，头部演员甚至达到了5万元一天，暴涨了近50倍。

这种暴涨背后的推手是一套极为精密的商业变现模式。一部长约80至100集的小程序短剧，制作成本通常控制在50万至80万元之间，拍摄周期仅为7到10天。然而，这样一部低成本短剧，在上线后的变现能力令人咋舌——通过"免费观看前10集、后续每集0.8至1.5元收费"的模式，一部爆款短剧的流水轻松突破千万元。据业内人士透露，去年某部现象级短剧的制作成本不到60万元，最终实现了超过8000万元的收入，投资回报率超过130倍。

短剧行业的暴利效应迅速吸引了大量资本涌入。过去两年，全国注册的短剧制作公司数量激增了超过5倍。为了抢到有经验的短剧演员，制作公司之间展开了激烈的价格战。一位短剧制片人向每日吃瓜坦言："现在好的短剧演员比传统影视剧的配角还难约。他们的档期已经排到了明年，你要是不给出足够高的价格，人家连剧本都不看。"

然而，暴利的另一面是极端的压榨。为了将拍摄周期压缩到最短，短剧剧组普遍采用每天16至18小时的超长工作模式。一位短剧演员在采访中抱怨："一天要拍30到40场戏，每场之间的台词全靠临时背，拍到后面台词连逻辑都不通顺了，但导演说没关系，反正观众看的是爽感，不会在意细节。"这种低质量、高强度的生产模式虽然短期内赚得盆满钵满，但长期来看，正在透支整个短剧行业的创作基础和观众信任。`,

    category: 'redianzonghe',
    author: '深度调查组',
    publishDate: '2026-06-22',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20short%20drama%20film%20set%20with%20crew%20and%20actors%20working%20intensely%2C%20modern%20mobile%20content%20creation%20atmosphere%2C%20warm%20studio%20lighting%2C%20documentary%20investigative%20style%2C%20fast-paced%20industry%20mood%2C%20behind%20the%20scenes%20editorial%20photography&width=800&height=500&seq=chigua-article-024&orientation=landscape',
    imageAlt: '短剧演员日薪暴涨揭秘产业链',
    views: 334500,
    comments: 13450,
    tags: ['短剧', '演员', '日薪', '产业链'],
    isHot: true,
    isExclusive: true,
  },
];

export function getArticlesByCategory(slug: string): Article[] {
  return articles.filter((a) => a.category === slug);
}

export function getArticleById(id: string): Article | undefined {
  return articles.find((a) => a.id === id);
}

export function getHotArticles(): Article[] {
  return articles.filter((a) => a.isHot);
}

export function getRelatedArticles(article: Article, limit: number = 4): Article[] {
  return articles
    .filter((a) => a.id !== article.id && (a.category === article.category || a.tags.some((t) => article.tags.includes(t))))
    .slice(0, limit);
}
